export default __webpack_public_path__ + "static/media/left.0bc151d2.svg";